import { render } from "./MotivoCita.vue?vue&type=template&id=155730b3&scoped=true"
import script from "./MotivoCita.vue?vue&type=script&lang=js"
export * from "./MotivoCita.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=155730b3&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-155730b3"]])

export default __exports__